// material-ui
import { useContext } from 'react';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { EventContext } from '../../event/eventContext';

export default function Footer() {
  const ev = useContext(EventContext);
  const brandName = ev?.brand?.name || 'Guestlist';
  const href =
    ev?.baseUrls?.public ||
    ev?.baseUrls?.frontend ||
    ev?.runtime?.frontendUrl ||
    (typeof window !== 'undefined' ? window.location.origin : '#');

  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}>
      {/* className is a styling hook for dark-themed routes (missions hub) */}
      <Typography variant="caption" className="app-footer-copy">
        &copy; All Rights Reserved{' '}
        <Link href={href} target="_blank" underline="hover">
          {brandName}
        </Link>
      </Typography>
      {/*} <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="https://codedthemes.com/about-us/" target="_blank" variant="caption" color="text.primary">
          About us
        </Link>
        <Link href="https://mui.com/legal/privacy/" target="_blank" variant="caption" color="text.primary">
          Privacy
        </Link>
        <Link href="https://mui.com/store/terms/" target="_blank" variant="caption" color="text.primary">
          Terms
        </Link>
      </Stack> */}
    </Stack>
  );
}
